
import React from 'react';
import { Card } from '../../../components/base/Card';
import { Button } from '../../../components/base/Button';

export const ServicesSection: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      id: 'basico',
      name: 'Paquete Básico',
      price: '$2,500',
      duration: '4-6 semanas',
      description: 'Análisis fundamental y recomendaciones estratégicas para empresas que buscan optimizar sus operaciones actuales.',
      features: [
        'Análisis FODA completo',
        'Evaluación de procesos actuales',
        'Recomendaciones estratégicas',
        'Plan de acción básico',
        '2 sesiones de consultoría',
        'Reporte ejecutivo detallado'
      ],
      icon: 'ri-lightbulb-line',
      color: 'from-green-400 to-green-600',
      popular: false
    },
    {
      id: 'intermedio',
      name: 'Paquete Intermedio',
      price: '$5,500',
      duration: '8-10 semanas',
      description: 'Estrategia personalizada con seguimiento continuo para empresas en crecimiento que necesitan dirección clara.',
      features: [
        'Todo lo del paquete básico',
        'Estrategia de crecimiento personalizada',
        'Análisis de competencia',
        'Plan de implementación detallado',
        '6 sesiones de consultoría',
        'Seguimiento mensual por 3 meses',
        'Optimización de procesos clave'
      ],
      icon: 'ri-trending-up-line',
      color: 'from-blue-400 to-blue-600',
      popular: true
    },
    {
      id: 'premium',
      name: 'Paquete Premium',
      price: '$12,000',
      duration: '12-16 semanas',
      description: 'Transformación empresarial completa con acompañamiento continuo para empresas que buscan reinventarse.',
      features: [
        'Todo lo del paquete intermedio',
        'Transformación organizacional completa',
        'Reestructuración estratégica',
        'Implementación de nuevos sistemas',
        'Consultoría ilimitada por 6 meses',
        'Capacitación del equipo directivo',
        'Soporte 24/7 durante implementación',
        'Garantía de resultados'
      ],
      icon: 'ri-trophy-line',
      color: 'from-purple-400 to-purple-600',
      popular: false
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Nuestros Servicios de Consultoría
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos tres niveles de consultoría estratégica diseñados para adaptarse a las necesidades 
            específicas de tu empresa, desde análisis básico hasta transformación completa.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service) => (
            <div key={service.id} className="relative">
              {service.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10">
                  <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                    Más Popular
                  </span>
                </div>
              )}
              
              <Card 
                className={`h-full transition-all duration-300 hover:shadow-xl ${service.popular ? 'ring-2 ring-blue-600 scale-105' : 'hover:scale-105'}`}
                padding="lg"
              >
                <div className="text-center mb-6">
                  <div className={`w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-r ${service.color} flex items-center justify-center`}>
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2">{service.name}</h4>
                  <div className="text-4xl font-bold text-gray-900 mb-1">{service.price}</div>
                  <div className="text-gray-600">{service.duration}</div>
                </div>

                <p className="text-gray-600 mb-6 text-center">{service.description}</p>

                <ul className="space-y-3 mb-8">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-check-line text-green-500 mr-3 mt-1 flex-shrink-0"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Button 
                  variant={service.popular ? 'primary' : 'outline'}
                  className="w-full"
                  onClick={scrollToContact}
                >
                  <i className="ri-arrow-right-line mr-2"></i>
                  Solicitar {service.name}
                </Button>
              </Card>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <Card className="max-w-4xl mx-auto bg-blue-50 border-blue-200">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-2-line text-2xl text-white"></i>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h4 className="text-xl font-bold text-gray-900 mb-2">¿No estás seguro cuál elegir?</h4>
                <p className="text-gray-600">
                  Agenda una consulta gratuita de 30 minutos y te ayudaremos a determinar 
                  el paquete perfecto para las necesidades de tu empresa.
                </p>
              </div>
              <Button variant="primary" onClick={scrollToContact}>
                Consulta Gratuita
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
